import { Image } from "@/components/image";
import { Spinner } from "@/components/ui/spinner";
import { useRouteContext } from "@tanstack/react-router";

export function ScreenLoading() {
	const { club } = useRouteContext({ from: "__root__" });

	return (
		<div className="w-100dvw py-48 h-100dvh min-w-100dvw min-h-100dvh flex items-center justify-center flex-col gap-3 bg-background text-foreground">
			<Image
				src={club.logo?.signedUrl!}
				width={800}
				height={800}
				className="size-48"
			/>

			<Spinner />
		</div>
	);
}
